import { createFileRoute } from '@tanstack/react-router';
import { Box, Stack } from '@mantine/core';
import { ProtectedComponent } from '@/features/auth/components/ProtectedComponent';
import { FallbackType, UserRole } from '@/features/auth/domain/auth.types';
import { PageHeader } from '@/shared/components/ui/PageHeader';
import { CustomerList } from '@/features/customers/components/CustomerList';
import { CustomerSearch } from '@/features/customers/components/CustomerSearch';
import { useCustomerSearch } from '@/features/customers/hooks/useCustomerSearch';
import { CustomerSearchFiltersSchema } from '@/features/customers/domain/customer.schemas';

export const Route = createFileRoute('/_authed/customers/')({
  component: CustomerListPage,
  validateSearch: CustomerSearchFiltersSchema,
});

function CustomerListPage() {
  const {
    filters,
    updateFilters,
    updatePageSize,
    toggleShowFavoritesOnly,
    customers,
    totalCount,
    isLoading,
    error,
    hasSearch,
  } = useCustomerSearch();

  const totalPages = Math.ceil(totalCount / filters.pageSize) || 0;

  const subtitle = hasSearch
    ? `Search results for "${filters.searchTerm}"`
    : 'Manage customer information and associations';

  return (
    <ProtectedComponent
      requiredRole={UserRole.Viewer}
      fallbackType={FallbackType.Page}
      fallbackTitle="Customers"
      fallbackAction="view customer information"
    >
      <Box>
        <Stack gap="lg">
          <PageHeader
            title="Customers"
            subtitle={subtitle}
            backButton={false}
          >
            <Box mt="md">
              <CustomerSearch
                filters={filters}
                onChange={updateFilters}
                onPageSizeChange={updatePageSize}
                isLoading={isLoading}
                showFavoritesOnly={filters.showFavoritesOnly}
                onToggleFavorites={toggleShowFavoritesOnly}
              />
            </Box>
          </PageHeader>

          <CustomerList
            customers={customers}
            totalCount={totalCount}
            totalPages={totalPages}
            page={filters.page}
            onPageChange={(page) => updateFilters({...filters, page})}
            isLoading={isLoading}
            error={error}
            showFavoritesOnly={filters.showFavoritesOnly}
          />
        </Stack>
      </Box>
    </ProtectedComponent>
  );
}